import { observable, computed, makeObservable } from 'mobx';
import { get } from '@utils/get';
import ListStore from '@stores/list';

// ActivityStore：兼容 list 组件用法，提供统一的列表数据、状态、属性获取接口
export class ProductStore {
    @observable namespace = 'product';

    @observable productList = null;
    @observable productMyList = null;
    @observable productData = null; // 产品详情数据

    constructor(initData = {}) {
        this.listStore = new ListStore();
        // 注册业务list
        this.listStore.registerList({ namespace: 'productList' });
        this.listStore.registerList({ namespace: 'productMyList' });
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.productList) {
            this.listStore.lists['productList'].data = initData.productList;
        }
    }

    /**
     * 获取列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get productListData() {
        return this.listStore.getList({ namespace: 'productList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get productListAttribs() {
        return this.listStore.lists['productList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get productListLoading() {
        return this.listStore.lists['productList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get productListError() {
        return this.listStore.lists['productList']?.requestError || { isError: false, errorText: '' };
    }


    /**
     * 获取用户收藏活动列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get productMyListData() {
        return this.listStore.getList({ namespace: 'productMyList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get productMyListAttribs() {
        return this.listStore.lists['productMyList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get productMyListLoading() {
        return this.listStore.lists['productMyList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get productMyListError() {
        return this.listStore.lists['productMyList']?.requestError || { isError: false, errorText: '' };
    }
}

// 不再导出 Store 实例，全部用 Action 实例